import { authAxios } from '@/common/axios';
import { noAccessAlert } from '@/common/utils/noAccessAlert';
import { checkPermission } from '@/common/utils/security';

export default {
  data() {
    return {
      isAccessAllowed: false,
    };
  },
  methods: {
    checkPermission(permId) {
      return checkPermission(permId);
    },
    checkPermissions(permIds) {
      if (this.$route.params.action === 'edit') {
        this.checkPermission(permIds[0]).then((response) => {
          if (!response.data) {
            noAccessAlert('У Вас нет доступа к редактированию объекта этого класса.');
            this.isReadonly = true;
          }
        });
      } else if (this.$route.params.action === 'view') {
        this.checkPermission(permIds[1]).then((response) => {
          if (!response.data) {
            this.notAccess();
          }
        });
      }
    },
    checkPermissionAndRedirect(permId) {
      return this.checkPermission(permId).then((response) => {
        const result = (this.isAccessAllowed = Boolean(response.data));
        if (!result) {
          this.notAccess();
        }
        return result;
      });
    },
    checkAnyPermission(permIds) {
      return authAxios.get(`/api/permission/any?permissionId=${permIds.join(',')}`);
    },
    getAccessMatrix() {
      return authAxios.get(`/api/permission/accessmatrix`);
    },
    getAccessList(permIds) {
      return authAxios.get(`/api/permission/accesslist`, { params: { permIds: permIds } });
    },
    notAccess(message) {
      this.$router.push('/');
      noAccessAlert(message);
    },
  },
};
